import { render, staticRenderFns } from "./ProRiskCanvas.vue?vue&type=template&id=d2348b4e&scoped=true&"
import script from "./ProRiskCanvas.vue?vue&type=script&lang=js&"
export * from "./ProRiskCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ProRiskCanvas.vue?vue&type=style&index=0&id=d2348b4e&scoped=true&lang=css&"
import style1 from "./ProRiskCanvas.vue?vue&type=style&index=1&id=d2348b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2348b4e",
  null
  
)

export default component.exports